export default class ProductInfoTabsService {
    initInfoTabs() {
        const tabHeaders = document.querySelectorAll('.info-tabs-list-item');
        const tabContents = document.querySelectorAll('.info-tabs-content-inner');
        if (!tabHeaders.length || !tabContents.length) {
            return;
        }
        const handleTabClick = (e) => {
            var _a, _b;
            e.preventDefault();
            const target = e.currentTarget;
            const tabIndex = Array.from(tabHeaders).indexOf(target);
            if (tabIndex === -1) {
                return;
            }
            tabHeaders.forEach((tab) => tab.classList.remove('active'));
            tabContents.forEach((content) => content.classList.remove('active'));
            (_a = tabHeaders[tabIndex]) === null || _a === void 0 ? void 0 : _a.classList.add('active');
            (_b = tabContents[tabIndex]) === null || _b === void 0 ? void 0 : _b.classList.add('active');
        };
        tabHeaders.forEach((tab) => {
            tab.addEventListener('click', handleTabClick);
        });
    }
    init() {
        this.initInfoTabs();
    }
}
